<template>
  <v-app>
    <!-- <transition name="slide-left"> -->
    <router-view class="child-view" />
    <!-- </transition> -->
  </v-app>
</template>

<script>
import getMetaInfoObject from '@/util/getMetaInfoObject';

export default {
  metaInfo: {
    titleTemplate: '%s - COVID-19 Hospital Status',
    ...getMetaInfoObject({
      title: 'COVID-19 Hospital Status',
      description:
        'If you are an EMT, primary care physician or patient, ' +
        'find hospitals near you with capacity. If you are a nurse, doctor, ' +
        'health department or state report on the status of a hospital.',
      image: 'https://covid19hospitalstatus.com/img/social.png',
      url: 'https://covid19hospitalstatus.com',
    }),
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: 'ttcommons';
  src: url('/fonts/TTCommons-Regular.eot');
  src: local('☺'), url('/fonts/TTCommons-Regular.woff') format('woff'),
    url('/fonts/TTCommons-Regular.ttf') format('truetype'),
    url('/fonts/TTCommons-Regular.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'ttcommons';
  src: url('/fonts/TTCommons-Medium.eot');
  src: local('☺'), url('/fonts/TTCommons-Medium.woff') format('woff'),
    url('/fonts/TTCommons-Medium.ttf') format('truetype'),
    url('/fonts/TTCommons-Medium.svg') format('svg');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'ttcommons';
  src: url('/fonts/TTCommons-DemiBold.eot');
  src: local('☺'), url('/fonts/TTCommons-DemiBold.woff') format('woff'),
    url('/fonts/TTCommons-DemiBold.ttf') format('truetype'),
    url('/fonts/TTCommons-DemiBold.svg') format('svg');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'ttcommons';
  src: url('/fonts/TTCommons-Bold.eot');
  src: local('☺'), url('/fonts/TTCommons-Bold.woff') format('woff'),
    url('/fonts/TTCommons-Bold.ttf') format('truetype'),
    url('/fonts/TTCommons-Bold.svg') format('svg');
  font-weight: bold;
  font-style: normal;
}

html,
body {
  padding: 0;
  margin: 0;
}

* {
  box-sizing: border-box;
  outline: none;
}

#app {
  --black: #1b0753;
  --dark-blue: #1a0952;
  --dark-blue-hover: #100432;
  --light-blue: #1c75fe;
  --light-dim-blue: #3373df;
  --red: #f15938;
  --orange: #f19938;
  --yellow: #ffce30;
  --very-light-blue: #aad0fb;
  --gray: #eeecec;
  --dark-gray: #a9a9a9;
  --darker-gray: #9c9c9c;
  --gray-transparent: rgba(27, 7, 83, 0.1);
  --gray-transparent-darker: rgba(27, 7, 83, 0.25);
  --off-white: #f1f1f1;
  --white: #fff;
  --white-transparent: rgba(255, 255, 255, 0.6);
  --white-transparent-lighter: rgba(255, 255, 255, 0.3);
  --page-padding: 30px;
  background: var(--gray);
  font-family: 'ttcommons', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: var(--black);
  position: relative;

  @media screen and (min-width: 768px) {
    --page-padding: 45px;
  }
}

.home-center {
  max-width: 400px;
  margin: auto;
  /* keep the submit button above the fold on mobile */
  height: 80vh;
  display: flex;
  flex-flow: column;
  padding: 40px 36px 36px 36px;
}

/* Remove arrows from numerical inputs */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.child-view {
  position: absolute;
  transition: transform 0.1s linear;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

// .slide-left-enter-active {
//   transform: translate(100%, 0);
// }

.mapboxgl-ctrl-icon {
  color: var(--dark-gray);
  font-size: 24px;
}

.mapboxgl-ctrl-zoom-in {
  .mapboxgl-ctrl-icon::before {
    content: '+';
  }
}

.mapboxgl-ctrl-zoom-out {
  .mapboxgl-ctrl-icon::before {
    content: '-';
  }
}
</style>
